import React, { useEffect, useState } from "react";
import { TbDatabaseImport } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import TimeConverter from "../../../functions/TimeConverter";
import BackupService from "../../../services/BackupService";
import "./FormBackup.css";
import { useBackup } from "../../../contexts/backup";

function FormBackup(props) {
	const [name, setName] = useState(props.backup?.bucketKey);
	const [date, setDate] = useState(props.backup?.uploadedAt);
	const [size, setSize] = useState(props.backup?.size);
	const [showLoader, setShowLoader] = useState(false);
	const { closeForm } = useListManager();
	const { selectedLicenceId } = useUserStore();
	const { setIsOpen, setBackup } = useBackup();

	useEffect(() => {
		setName(props.backup?.bucketKey);
		setDate(TimeConverter(props.backup?.uploadedAt, 1));
		setSize(props.backup?.size);
	}, [props.backup]);

	const navigate = useNavigate();

	async function handleDelete() {
		setShowLoader(true);
		if (!props.backup) return;
		await BackupService.deleteBackupById(props.backup.id, selectedLicenceId);
		navigate("../consulta-backups", {
			state: { deletedId: props.backup.id },
		});
		setShowLoader(false);
		closeForm();
	}

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				tituloConsulta={props.backup?.name || null}
				tituloCadastro="Backups"
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					type={props.type}
					handleDelete={handleDelete}
					navigateCancelUrl="../consulta-backups"
					aditionalButton={(props.backup && ![1, 4, 5].includes(props.backup?.status)) &&
						<Button
							icon={<TbDatabaseImport size={16} />}
							className="button-blue"
							label="Importar"
							onClick={() => {
								setIsOpen(true);
								setBackup(props.backup);
							}}
						/>
					}
				>
					<Input
						name={"name"}
						id="name"
						labelText={"Nome *"}
						value={name}
						onChange={({ target }) => setName(target.value)}
						disabled={props.type === "consulta"}
						required={true}
					></Input>
					{date && (
						<Input
							type="date"
							labelText={"Data de Início"}
							value={date}
							required={false}
							onChange={({ target }) => setDate(target.value)}
							disabled={props.type === "consulta"}
						></Input>
					)}
					<Input
						name={"size"}
						id="size"
						labelText={"Tamanho *"}
						value={size}
						disabled={props.type === "consulta"}
						required={true}
					></Input>
				</Form>
			)}
		</React.Fragment>
	);
}

export default FormBackup;
